import Decimal from 'decimal.js'

/** Parse a Decimal-as-string into a finite Decimal, or null when missing/unparseable. */
export function parseDecimal(value: string | null | undefined): Decimal | null {
  if (value == null || value.trim() === '') return null
  try {
    const d = new Decimal(value)
    return d.isFinite() ? d : null
  } catch {
    return null
  }
}

/**
 * Format a Decimal-as-string USD amount as "$1,234.56", negatives as
 * "-$1,234.56" (2 dp). Returns "—" for missing/unparseable input; a genuine "0"
 * renders as "$0.00". Grouping is done on the Decimal's own digit string —
 * never via Number() — so whale-scale notionals keep full precision, and a
 * value that rounds to zero never shows a phantom "-$0.00".
 */
export function formatUsd(value: string | null | undefined): string {
  const d = parseDecimal(value)
  if (d === null) return '—'
  const fixed = d.abs().toFixed(2) // "1234.50"
  const [intPart, frac] = fixed.split('.')
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const body = `$${grouped}.${frac}`
  return d.isNegative() && fixed !== '0.00' ? `-${body}` : body
}
